import React from 'react';
import { Layers, Palette, Rocket, Users } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: Palette,
      title: 'UI/UX Design',
      description: 'Beautiful, intuitive interfaces that users love to interact with.',
      features: ['User Research', 'Wireframing', 'Prototyping', 'Design Systems']
    },
    {
      icon: Layers,
      title: 'Full-Stack Development',
      description: 'Robust applications built with cutting-edge technology stacks.',
      features: ['Frontend Development', 'Backend APIs', 'Database Design', 'Cloud Infrastructure']
    },
    {
      icon: Rocket,
      title: 'AI & ML Solutions',
      description: 'Intelligent features powered by artificial intelligence and machine learning.',
      features: ['Natural Language Processing', 'Computer Vision', 'Predictive Analytics', 'Automation']
    },
    {
      icon: Users,
      title: 'Consulting & Strategy',
      description: 'Expert guidance to help you make the right technology decisions.',
      features: ['Technical Architecture', 'Product Strategy', 'Team Training', 'Code Reviews']
    }
  ];

  return (
    <section id="services" className="relative py-24 overflow-hidden">
      {/* Image Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_creative-studio-146/artifacts/cx3b8wwr_sanjuanventures_An_East_african_young_woman_with_long_neatly__6daa9f18-8b81-4aae-b121-4b6b9bc2f5d3_3.png"
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4 drop-shadow-lg">
            Our <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">Services</span>
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto drop-shadow-md">
            Comprehensive digital solutions tailored to your business needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div 
                key={index}
                className="group bg-white/5 backdrop-blur-sm p-8 rounded-2xl border-2 border-white/10 hover:border-violet-400/50 transition-all duration-300 hover:shadow-xl"
              >
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-violet-600 to-pink-600 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-2 drop-shadow-lg">{service.title}</h3>
                    <p className="text-white/90 drop-shadow-md">{service.description}</p>
                  </div>
                </div>
                <ul className="mt-6 space-y-2 ml-20">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-white/80 drop-shadow-md">
                      <div className="w-1.5 h-1.5 rounded-full bg-pink-400 mr-3"></div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;